import React, { lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import { LOGIN_PATH, normalizeAuthSearch } from 'utils/session/authRoutes';
import { clarityEvent } from 'utils/tracking';

const Authentication = lazy(() => import('views/Authentication'));

/**
 * The bare /auth is an alias kept for links already out there — the registration
 * email among them. It forwards with replace, so the alias never becomes a history
 * entry of its own, and forwards only what the login route can use.
 */
const AuthAliasRedirect = ({ location }) => {
  // Counted so the alias can be retired once nothing reaches it any more.
  useEffect(() => {
    clarityEvent('auth_alias_redirect');
  }, []);

  return (
    <Redirect
      to={{
        pathname: LOGIN_PATH,
        search: normalizeAuthSearch(location.search),
        state: location.state,
      }}
    />
  );
};

AuthAliasRedirect.propTypes = {
  location: PropTypes.object.isRequired,
};

const AuthRoute = (props) =>
  props.match.params.view
    ? <Authentication {...props} />
    : <AuthAliasRedirect location={props.location} />;

AuthRoute.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default AuthRoute;
